import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-white text-lg font-medium" }, "Phone dialer", -1)

import { computed, defineAsyncComponent, onMounted } from "vue"
import { XIcon } from "@heroicons/vue/outline"
import { LoginIcon } from "@heroicons/vue/solid"
import { usePhoneCallStore } from "@/stores/phone-call"
import { PhoneCall } from "@/shared/models/phone-call"
import { useFormStore } from "@/stores/form"

interface Props {
    modelValue: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneCallSidebar',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const formStore = useFormStore()

const props = __props
const emit = __emit

const phoneCallStore = usePhoneCallStore()

const isPhoneCallInProgress = computed(() => ["calling", "ongoing"].includes(phoneCallStore.phoneCallState))

const phoneCallComponent = computed(() => {
    if (["calling", "ongoing", "finished"].includes(phoneCallStore.phoneCallState)) {
        return phoneComponents.inProgress
    }
    return phoneComponents[phoneCallStore.phoneCallState]
})

const phoneComponents = {
    idle: defineAsyncComponent(() => import("@/components/phone-sidebar/PhoneCallIdle.vue")),
    inProgress: defineAsyncComponent(() => import("@/components/phone-sidebar/PhoneCallInProgress.vue")),
    message: defineAsyncComponent(() => import("@/components/phone-sidebar/PhoneTextMessage.vue")),
}

const isPhoneSidebarVisible = computed({
    get: () => props.modelValue,
    set: (value: boolean) => {
        emit("update:modelValue", value)
    },
})

function closeDialog() {
    if (!isPhoneCallInProgress.value) {
        phoneCallStore.currentPhoneCall = {} as Partial<PhoneCall>
        phoneCallStore.phoneCallState = "idle"
    }
    isPhoneSidebarVisible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createBlock(_component_Sidebar, {
    visible: isPhoneSidebarVisible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((isPhoneSidebarVisible).value = $event)),
    position: "right",
    autoZIndex: "",
    showCloseIcon: false
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (isPhoneCallInProgress.value)
          ? (_openBlock(), _createBlock(_unref(LoginIcon), {
              key: 0,
              class: "h-6 w-6 text-white cursor-pointer rotate-180",
              onClick: closeDialog
            }))
          : (_openBlock(), _createBlock(_unref(XIcon), {
              key: 1,
              class: "h-6 w-6 text-white cursor-pointer",
              onClick: closeDialog
            }))
      ])
    ]),
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(phoneCallComponent.value)))
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})